'use strict';

const {localStorage, sessionStorage} = require('dibs-browser-storage');
const enabler = require('../utils/enabler');

const MAX_SESSIONS = 3;

const tradeMessageActions = {

    checkTradeMessage(actionContext, payload, done) {
        const {tradeSalesRep} = payload;
        const isMessageDisabled = !enabler.isEnabled('trade_welcome_message');

        if (isMessageDisabled) {
            done();
        } else {
            const showCount = localStorage.getItem('tradeWelcomeMessage') || 0;
            const canShowByCount = showCount <= MAX_SESSIONS;

            if (canShowByCount && tradeSalesRep) {
                actionContext.executeAction(tradeMessageActions.showTradeMessage).then(() => done());
            } else {
                done();
            }
        }
    },

    incrementShowCount(actionContext, payload, done) {
        let showCount = localStorage.getItem('tradeWelcomeMessage') || 0;
        const isFirstInSession = !sessionStorage.getItem('tradeWelcomeMessage');
        if (isFirstInSession) {
            localStorage.setItem('tradeWelcomeMessage', ++showCount);
            sessionStorage.setItem('tradeWelcomeMessage', true);
        }
        done();
    },

    showTradeMessage(actionContext, payload, done) {
        actionContext.executeAction(tradeMessageActions.incrementShowCount);
        actionContext.dispatch('message:trade:toggle', true);
        done();
    },

    hideTradeMessage(actionContext, payload, done) {
        actionContext.dispatch('message:trade:toggle', false);
        localStorage.setItem('tradeWelcomeMessage', MAX_SESSIONS + 1);
        done();
    }

};

module.exports = tradeMessageActions;



// WEBPACK FOOTER //
// ./assets/js/global/actions/tradeMessageActions.es.js